import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ProgressBarContainer = styled.div<{ timeshift?: boolean }>`
  cursor: ${(props) => (props.timeshift ? 'pointer' : 'default')};
  position: absolute;
  bottom: ${110 * Screen.widthRatio}px;
  padding: ${30 * Screen.widthRatio}px 0;
  right: ${581 * Screen.widthRatio}px;
  width: ${1060 * Screen.widthRatio}px;
`;

export default ProgressBarContainer;
